import type { SanityImageData } from "library/sanity/SanityImage"

/**
 * CarouselBackgroundVideo paints the Mux thumbnail as an unquoted CSS url().
 * Browsers rewrite that during hydration. Passing a poster skips the background,
 * and an image with no asset renders nothing, so callers can show their own still.
 */
export const suppressedMuxPoster = {
	data: null,
} satisfies SanityImageData<"false">

export function muxThumbnailUrl(playbackId: string) {
	return `https://image.mux.com/${playbackId}/thumbnail.webp?time=0&width=640`
}
